module.exports = __webpack_public_path__ + "static/media/Times.af465c82.png";